import { useQuery } from '@tanstack/react-query';
import { getPayments } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';

export const usePayments = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.subscription.payments(),
        queryFn: getPayments,
        enabled: options?.enabled ?? true,
    });
};
